import {compareHash, createHash} from './util/asyncHash';

class Modal {
  constructor() {
    this.modal = document.querySelector('.rp-modal-backdrop-wrapper');
    this.backdrop = this.modal.querySelector('.rp-modal-backdrop');
    this.modalElement = this.modal.querySelector('.rp-modal');
  }

  init(delay = 0) {
    if (delay) {
      return setTimeout(() => {
        this.init();
      }, delay)
    }

    Promise.resolve(this.shouldDisplay())
      .then(shouldDisplay => {
        if (shouldDisplay) {
          this.modal.style = '';
          this.backdrop.style = 'opacity: 0;'
          this.modalElement.style = 'opacity: 0; transform: translateX(200%);';
          this.modal.removeAttribute('tabindex');
          document.documentElement.style.overflow = 'hidden';

          this.animateIn();

          if (!this.shouldAnimate()) {
            this.backdrop.style = '';
            this.modalElement.style = '';
          }
        }
      })
  }

  withCloseActions() {
    const buttons = this.modal.querySelectorAll('[data-action="close"]')
    buttons.forEach(button => {
      button.addEventListener('click', this.outEvent.bind(this));
    })

    document.addEventListener('keydown', (e) => {
      // On escape, close the modal
      if (e.key.toLowerCase() === 'escape') {
        this.outEvent();
      }
    })

    return this;
  }

  outEvent() {
    this.animateOut();
    this.modal.style.pointerEvents = 'none';
    document.documentElement.style.overflow = '';
    if (!this.shouldAnimate()) {
      this.modalElement.style.display = 'none';
      this.backdrop.style.display = 'none';
    }

    // This sets a content variable with all the text in the modal, removes all whitespace and then hashes it with createHash.
    const content = this.modalElement.textContent.replace(/\s+/g, '');

    // Async function that creates a hash from the content variable
    createHash(content)
      .then(hash => window.localStorage.setItem('dismissible-popup-hash', hash));
  }

  shouldDisplay() {
    const content = this.modalElement.textContent.replace(/\s+/g, '');

    // Check if local storage with dismissible-popup-hash exists
    if (!window.localStorage.getItem('dismissible-popup-hash')) {
      return true;
    }

    // If it does, compare the hash with the content
    const hash = window.localStorage.getItem('dismissible-popup-hash');

    return compareHash(hash, content)
      .then(result => !result)
  }

  animateIn() {
    if (!this.shouldAnimate()) {
      return;
    }

    this.backdrop.animate([
      {
        opacity: 0,
      },
      {
        opacity: 1,
      },
    ], {
      duration: 200,
      delay: 300,
      fill: 'forwards',
    })

    this.modalElement.animate([
      {
        opacity: 0,
        transform: 'translateX(200%)',
      },
      {
        opacity: 1,
        transform: 'translateX(0)',
      },
    ], {
      delay: 1000,
      duration: 500,
      easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
      fill: 'forwards',
    });
  }

  animateOut() {
    if (!this.shouldAnimate()) {
      return;
    }

    this.modalElement.animate([
      {
        opacity: 1,
        transform: 'translateX(0)',
      },
      {
        opacity: 0,
        transform: 'translateX(-200%)',
      },
    ], {
      duration: 500,
      easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
      fill: 'forwards',
    });

    this.backdrop.animate([
      {
        opacity: 1,
      },
      {
        opacity: 0,
      },
    ], {
      duration: 100,
      delay: 300,
      fill: 'forwards',
    })
  }

  shouldAnimate() {
    return this.modal.getAttribute('data-animation') === '1';
  }
}

window.SingletonModal = new Modal();

document.addEventListener('DOMContentLoaded', () => {
  window
    .SingletonModal
    .withCloseActions()
    .init(3000);
})



// WEBPACK FOOTER //
// ./scripts/modal.iife.js